import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, trackEvent } from "@/lib/analytics";

// V1.1-Beta — Page view tracker. Mounted once inside <BrowserRouter> so it
// observes every client-side navigation and fires one `page_view` per route
// change. Also fires a one-off `landing_view_hero` on the landing page.
export default function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
    if (location.pathname === "/") {
      trackEvent("landing_view_hero");
    }
  }, [location.pathname]);
  return null;
}
